export const packageService = () => {
  const packageCMS = "/dtvassets/dtv/dev/uf/CHLUP/channelListingNewPageData.json";
  return fetch(packageCMS).then(res => res.json()).catch(error => {
    console.log("Error in Package Info", error);
    return [];
  });
};

export const fetchOVMultisearchData = async (searchTxt: string, searchCategory: string) => {
  const url = `/uf/api/catalog/search?query=${encodeURIComponent(searchTxt)}&category=${encodeURIComponent(searchCategory)}`;
  try {
    const response = await fetch(url);
    if (!response.ok) {
      console.error('[MultisearchService] catalog search failed with status', response.status);
      return null;
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('[MultisearchService] catalog search request failed', error);
    return null;
  }
};
